import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  Flex,
  Box,
  Button,
  Text,
  VStack,
  HStack,
  Circle,
  Image,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import { useDragControls } from "framer-motion";
import logo from "../../assets/logo.png";
import correct from "../../assets/svgs/correct-mark.svg";
import { useNavigate } from "react-router-dom";

const cards = [
  {
    title: "How it works",
    description: "Includes how we calculate the amount & Stuff.",
    details: [
      "We charge cleaning cost where necessary £3.95 for garment and £5.50 for outerwear ",
      "Returned items inccurr a charge of £2.95 per items ",
      "Get paid by cash or credit ",
    ],
  },
  {
    title: "Items we accept",
    description: "Includes how we calculate the amount & Stuff.",
    details: [
      "We accept all genders from new born to 14 years",
      "We accept all garment, outerwear, accessories and unworn footwear",
      "We accept only designer brands,  not high street (link to search brands? )",
      "We accept items where the original RRP is above £45 ",
      "We accept item that are new with or without tags or barely worn items (no stains, tears or wear)",
    ],
  },
  {
    title: "Tracking Items",
    description: "Includes how we calculate the amount & Stuff.",
    details: [
      "We send you processed items for approval before they are listed",
      "Rejected items are donated to our charity partners",
      "Returned items inccur a cost of £2.95 per item ",
      "Items status can be tracked online",
      "We sell items online and across our department stores and pop-ups",
    ],
  },
  {
    title: "Pricing",
    description: "Includes how we calculate the amount & Stuff.",
    details: [
      "We calculuate resale prices based on brand and condition of the item (typical resale prices are 60% of the orirginal RRP)",
      "We dynamically reduce resale priaces to help them sell quuickly (typically by an additional 10% every 3 months)",
    ],
  },
  {
    title: "Payment Calculations",
    description: "Includes how we calculate the amount & Stuff.",
    details: [
      "We pay 50% commssion of the price sold",
      "Payments are made at the end of each month follwing a 30 days return period we offer customers.",
    ],
  },
  {
    title: "Hidden costs",
    description: "Includes what items do we accept & in which condition.",
    details: [
      "We charge cleaning cost where necessary £3.95 for garment and £5.50 for outerwear ",
      "Returned items inccurr a charge of £2.95 per items ",
    ],
  },
];

export default function AuthFAQS() {
  const [index, setIndex] = useState(0);
  const controls = useDragControls();
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => setIsReady(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const nextSlide = () => {
    if (index < cards.length - 1) {
      setIndex((prev) => prev + 1);
    }
  };

  const prevSlide = () => {
    if (index > 0) {
      setIndex((prev) => prev - 1);
    }
  };

  return (
    <VStack spacing={5} align="center" p={3}>
      <Image src={logo} height={20} />
      <Text
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={"28px"}
        color={"#000000"}
        textAlign={"center"}
        textTransform={'uppercase'}
      >
        Selling with Kidswear Collective
      </Text>
      <Flex justify="center" align="center" gap={8} py={1} px={5} wrap="wrap">
        {/* Card 1 */}
        <Box
          minH="430px"
          w="350px"
          border="1px solid #000"
          p={6}
          borderRadius="4px"
        >
          <Text
            textAlign="center"
            textTransform="uppercase"
            fontFamily="PlusJakartaSansMedium"
            fontSize="20px"
            fontWeight={700}
            color="#2D3139"
            mb={5}
          >
            Items We Accept
          </Text>

          <UnorderedList spacing={3} styleType="disc" pl={5}>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              Girls and boys clothes, accessories and footwear
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              From newborn to 14 years
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              Only designer/premium brands (not high street or fast fashion)
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              Only Items with original RRP of £45 or above
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              Only items that are pristine or gently worn condition
            </ListItem>
          </UnorderedList>
        </Box>

        {/* Card 2 */}
        <Box
          minH="430px"
          w="350px"
          border="1px solid #000"
          p={6}
          borderRadius="4px"
        >
          <Text
            textAlign="center"
            textTransform="uppercase"
            fontFamily="PlusJakartaSansMedium"
            fontSize="20px"
            fontWeight={700}
            color="#2D3139"
            mb={5}
          >
            How We Work
          </Text>

          <UnorderedList spacing={3} styleType="disc" pl={5}>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              We arrange collections or accept drop-offs at our London HQ
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              We inspect, grade, price, photograph, list and store all items
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              We sell items online and across stores
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              We update item status in real-time
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              Sale proceeds are split 50% with sellers
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              Payments made 30 days after being sold to allow refunds
            </ListItem>
          </UnorderedList>
        </Box>

        {/* Card 3 */}
        <Box
          minH="430px"
          w="350px"
          border="1px solid #000"
          p={6}
          borderRadius="4px"
        >
          <Text
            textAlign="center"
            textTransform="uppercase"
            fontFamily="PlusJakartaSansMedium"
            fontSize="20px"
            fontWeight={700}
            color="#2D3139"
            mb={5}
          >
            Registering
          </Text>

          <UnorderedList spacing={3} styleType="disc" pl={5}>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              We only collect from UK postal addresses
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              We request an initial minimum of 10 items
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              Register your details for pre-approval
            </ListItem>
            <ListItem
              fontFamily="PlusJakartaSansRegular"
              fontSize="16px"
              color="#3F4550"
            >
              Log into your account to complete details and request mailing bags
              or drop-off
            </ListItem>
          </UnorderedList>
        </Box>
      </Flex>

      {/* <HStack
        spacing={0}
        position="relative"
        height="670px"
        width="1420px"
        justify="center"
        overflow="hidden"
      >
        {isReady &&
          cards.map((card, i) => {
            let position = i - index;
            if (index === 0 && i === cards.length - 1) {
              position = -1;
            }
            if (index === cards.length - 1 && i === 0) {
              position = 1;
            }
            return (
              <motion.div
                key={i}
                drag="x"
                dragControls={controls}
                onDragEnd={(event, info) => {
                  if (info.offset.x < -50) nextSlide();
                  if (info.offset.x > 50) prevSlide();
                }}
                animate={{
                  scale: 1,
                  opacity: position === 0 ? 1 : 0.5,
                  filter: position === 0 ? "blur(0px)" : "blur(2px)",
                  x: `${position * 470}px`,
                }}
                transition={{ type: "spring", stiffness: 300, damping: 50 }}
                style={{
                  position: "absolute",
                  width: "450px",
                  height: "650px",
                }}
              >
                <Box
                  bg="white"
                  p={5}
                  shadow="lg"
                  // rounded="lg"
                  borderRadius={"18px"}
                  textAlign="left"
                  height="100%"
                  border="3px solid #456EFF"
                  overflow="hidden"
                  onClick={
                    position > 0 ? nextSlide : position < 0 ? prevSlide : null
                  }
                >
                  <Button mb={4} color="#456EFF" bgColor="#456EFF1F">
                    FAQ's
                  </Button>
                  <Text
                    fontFamily={"PlusJakartaSansMedium"}
                    fontSize={"40px"}
                    fontWeight={700}
                    lineHeight={"48px"}
                    color={"#2D3139"}
                    mt={2}
                  >
                    {card.title}
                  </Text>
                  <Text
                    mt={8}
                    fontFamily={"PlusJakartaSansRegular"}
                    fontWeight={400}
                    fontSize={"18px"}
                    lineHeight={"100%"}
                    color={"#3F4550"}
                    mb={4}
                  >
                    {card.description}
                  </Text>
                  <Box>
                    {card.details.map((detail, i) => (
                      <Flex
                        key={i}
                        flex={1}
                        direction="row"
                        gap={3}
                        alignItems="center"
                      >
                        <Image src={correct} mt={7} />
                        <Text
                          fontFamily={"PlusJakartaSansRegular"}
                          fontWeight={400}
                          fontSize={"18px"}
                          lineHeight={"28px"}
                          color={"#000000"}
                          width="90%"
                          mt={6}
                        >
                          {detail}
                        </Text>
                      </Flex>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            );
          })}
      </HStack> */}

      <Flex direction="row" flex={1} width="100%" alignItems={"center"}>
        {/* Centered Dots */}
        {/* <Flex gap={4} width="100%" justify="flex-end">
          {cards.map((_, i) => (
            <Circle
              key={i}
              size="10px"
              bg={i === index ? "#456EFF" : "gray.300"}
              transition="all 0.3s ease"
              cursor="pointer"
              onClick={() => setIndex(i)}
            />
          ))}
        </Flex> */}
        {/* Button at the Bottom */}
        <Flex width="100%" justify="center">
          <Button
            onClick={() => navigate("/terms-and-conditions")}
            width="200px"
            height="48px"
            backgroundColor={"#000"}
            color="white"
            textTransform={"uppercase"}
          >
            Register
          </Button>
        </Flex>
      </Flex>
    </VStack>
  );
}
